import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUserSettingsStore = defineStore(
    'userSettings',
    () => {
        const state = ref(null);
        const updateState = function (newState) {
            state.value = {...state.value, ...newState};
        };
        return {state, updateState};
    },
    {
        persist: true,
    }
);